import { type ClientContext, ContextClient } from '~/services/contextClient';
import ReservedDatesClientFactory from './reservedDatesClient.factory';
import type { ReservedDatesClientInterface, ReservedDate, StoreReservedDatePayload } from './reservedDatesClient.types';
import type { CursorPaginationResponse, QueryParams } from '~/services/api';
import type { AxiosPromise } from 'axios';

class ReservedDatesClient extends ContextClient<ReservedDatesClientInterface> {
    constructor() {
        super(ReservedDatesClientFactory);
    }

    getReservedDates(
        context: ClientContext,
        params?: QueryParams
    ): AxiosPromise<CursorPaginationResponse<ReservedDate>> {
        const client = this.getClient(context);
        return client.getReservedDates(params);
    }

    getReservedDate(context: ClientContext, reservedDateId: number): AxiosPromise<ReservedDate> {
        const client = this.getClient(context);
        return client.getReservedDate(reservedDateId);
    }

    createReservedDate(context: ClientContext, data: StoreReservedDatePayload): AxiosPromise<ReservedDate> {
        const client = this.getClient(context);
        return client.createReservedDate(data);
    }

    updateReservedDate(
        context: ClientContext,
        reservedDateId: number,
        data: StoreReservedDatePayload
    ): AxiosPromise<ReservedDate> {
        const client = this.getClient(context);
        return client.updateReservedDate(reservedDateId, data);
    }

    deleteReservedDate(context: ClientContext, reservedDateId: number): AxiosPromise<void> {
        const client = this.getClient(context);
        return client.deleteReservedDate(reservedDateId);
    }
}

export default new ReservedDatesClient();
